import type { MenuLink } from './menu-types';

/**
 * Ветка пункта меню: `shop.products.index` отвечает за весь `shop.products.*`,
 * а `shop.stock` и `shop.showcase` — самостоятельные пункты того же раздела.
 *
 * Сводить имя к первому сегменту нельзя: тогда любой `shop.*` подсвечивал бы
 * сразу все пункты магазина и клик по соседнему считался бы повтором.
 */
export const routeBranch = (name: string): string => (name.endsWith('.index') ? name.slice(0, -'.index'.length) : name);

/** Активен ли сейчас маршрут пункта меню: он сам или маршрут внутри его ветки. */
export const isActiveRouteName = (currentName: string, targetName: string): boolean => {
  if (currentName === '' || targetName === '') {
    return false;
  }

  if (currentName === targetName) {
    return true;
  }

  const branch = routeBranch(targetName);

  return currentName === branch || currentName.startsWith(`${branch}.`);
};

/** Активен ли пункт меню при текущем имени маршрута `currentName`. */
export const isMenuLinkActive = (link: MenuLink, currentName: string): boolean => {
  const targetName = (link.to as { name?: string }).name;

  return targetName ? isActiveRouteName(currentName, targetName) : false;
};
